import { useGetBundleByToken } from "../hooks/useMyRecommendations";
import Loader from "../components/Loader";
import ErrorMessage from "../components/ErrorMessage";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { checkLogin, isProLoggedIn, isRetailLoggedIn } from "../utils/jwt";
import { InvalidBundleState } from "../atoms/bundleAtom";
import { useSetRecoilState } from "recoil";
import { useStoreLabel } from "../hooks/useStore";

const RecommendationPage = () => {
  const isLoggedIn = checkLogin();
  const isPro = isProLoggedIn();
  const isRetailer = isRetailLoggedIn();
  const { bundleToken, accountId } = useParams();
  const navigate = useNavigate();
  const setInvalidBundle = useSetRecoilState(InvalidBundleState);
  const { data, isLoading, isError, error } = useGetBundleByToken(bundleToken);
  const {
    data: storeData,
    isLoading: isLoadingStore,
    isError: isStoreError,
  } = useStoreLabel(accountId);

  const handleNavigation = useCallback(() => {
    if (!isLoadingStore && !isLoading && !isError && !isStoreError) {
      if (isLoggedIn) {
        if (data) {
          if (isPro) {
            navigate("/b2b/my-store/my-recommendations");
          } else if (data.isRetail) {
            navigate("/cart", {
              state: {
                backgroundLocation: {
                  hash: "",
                  key: "default",
                  pathname: "/",
                  search: "",
                  state: null,
                },
              },
            });
          } else if (isRetailer) {
            setInvalidBundle(true);
            navigate("/retail");
          }
        }
      } else {
        navigate("/register-retail", {
          state: {
            from: { pathname: `/recommendations/${bundleToken}/${accountId}` },
          },
        });
      }
    }
  }, [
    isLoading,
    isLoadingStore,
    isStoreError,
    isError,
    data,
    navigate,
    isLoggedIn,
    isPro,
    isRetailer,
    bundleToken,
    setInvalidBundle,
    accountId,
  ]);

  useEffect(() => {
    handleNavigation();
  }, [handleNavigation]);

  if (isLoading || isLoadingStore) {
    return <Loader />;
  }

  if (isError) {
    return (
      <ErrorMessage
        style={{ minHeight: "52vh" }}
        errorMessage={error.message}
      />
    );
  }

  if (isStoreError || accountId !== storeData?.accountId) {
    return (
      <ErrorMessage
        style={{ minHeight: "52vh" }}
        errorMessage="Invalid bundle URL"
      />
    );
  }

  return null;
};

export default RecommendationPage;
